import React, { useEffect } from "react";
import { useState } from "react";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";

const MonthlyYearlyGraph = ({ data }) => {
  const [chartData, setChartData] = useState(null);
  const [checkBox, setCheckBox] = useState(false);

  const transformData = (data, avg_per_Day, filtered_by = "month") => {
    // Validate input data
    if (!data || !Array.isArray(data) || data.length === 0) {
      return { dimensions: [], series: [] };
    }

    // Find the data for the specified filtered_by
    const filteredData = data.find((item) => {
      return item.filtered_by === filtered_by;
    });
    if (!filteredData) {
      return { dimensions: [], series: [] };
    }

    // Helper function to calculate days between two dates
    function getDaysBetween(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (isNaN(start) || isNaN(end)) {
        return 1;
      }
      const diffTime = Math.abs(end - start);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Include end date
    }

    // Define dimensions
    const dimensions = [
      "product",
      `${filteredData.previous.start_date.split("-")[0]}-${
        filteredData.current.start_date.split("-")[0]
      }`,
      `${filteredData.current.start_date.split("-")[0]}-${
        parseInt(filteredData.current.start_date.split("-")[0]) + 1
      }`,
    ];

    // Initialize series array
    const series = [];

    // Get number of days for average calculation if needed
    const prevDays = avg_per_Day
      ? getDaysBetween(
          filteredData.previous.start_date,
          filteredData.previous.end_date
        )
      : 1;
    const currDays = avg_per_Day
      ? getDaysBetween(
          filteredData.current.start_date,
          filteredData.current.end_date
        )
      : 1;

    // Process each product
    filteredData.current.data.forEach((currentItem) => {
      const previousItem = filteredData.previous.data.find(
        (item) => item.NAME === currentItem.NAME
      );
      if (previousItem) {
        // Calculate ratios with safety checks
        const prevIRE = parseFloat(previousItem.IRE_tot) || 0;
        const prevYDAY = parseFloat(previousItem.Y_DAY_O_B_tot) || 1; // Avoid division by zero
        const currIRE = parseFloat(currentItem.IRE_tot) || 0;
        const currYDAY = parseFloat(currentItem.Y_DAY_O_B_tot) || 1; // Avoid division by zero

        const prevRatio = ((prevIRE / prevYDAY) * 100) / prevDays;
        const currRatio = ((currIRE / currYDAY) * 100) / currDays;

        series.push({
          [dimensions[1]]: isNaN(prevRatio) ? 0 : prevRatio.toFixed(2),
          [dimensions[2]]: isNaN(currRatio) ? 0 : currRatio.toFixed(2),
          product: currentItem.NAME,
        });
      }
    });

    return { dimensions, series };
  };

  useEffect(() => {
    if (data && data.length > 0) {
      // Changed from data.length > 1 to > 0
      const transData = transformData(data, checkBox, "month");
      setChartData(transData);
    }
  }, [data, checkBox]);
  return (
    <div className="">
      <div className="row">
        <h6 className="p-1 bg-dark text-white">
          IRE Month wise data (PERCENTILE)
        </h6>
        {!data ? (
          <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
        ) : null}
        {chartData && (
          <GroupedBarChart
            height={320}
            data={chartData}
            from="IRE" //for same graph design as the PDD_C
            chartType="bar"
          />
        )}
      </div>
      <div className="d-flex">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={checkBox}
            onChange={() => setCheckBox(!checkBox)}
            id="avgPerDayCheck"
          />
          <label className="form-check-label" htmlFor="avgPerDayCheck">
            Avg per Day
          </label>
        </div>
      </div>
    </div>
  );
};

export default MonthlyYearlyGraph;
